import { configureChains, createConfig, useAccount, useBalance } from 'wagmi'
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
import { mainnet,bsc} from 'viem/chains';
import { chainId, PUBLIC_NODES } from './chain';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'
import { formatEther } from 'viem';


export const CHAINS = [mainnet,bsc]

const mostNodesConfig = Object.values(PUBLIC_NODES).reduce((prev, cur) => {
	return cur.length > prev ? cur.length : prev
}, 0)

export const { chains, publicClient } = configureChains(
	CHAINS,
	Array.from({ length: mostNodesConfig })
		.map((_, i) => i)
		.map((i) => {
			return jsonRpcProvider({
				rpc: (chain) => {
					return PUBLIC_NODES[chain.id]?.[i]
						? {
							http: PUBLIC_NODES[chain.id][i]
						}
						: null
				}
			})
		})
)

export const metaMaskConnector = new MetaMaskConnector({
	chains,
	options: {
		shimDisconnect: true,
	}
})





export const wagmiConfig = createConfig({
	autoConnect: true,
	chains,
	publicClient,
	connectors: [metaMaskConnector]
})


// 11155111
